import { SyncModelPermissionEntryWithStatus } from "@/domains/sync-scopes/types";
import { filter } from "lodash-es";

export const getGrantedCollectionIdsForPermissions = ({
  permissions,
}: {
  permissions: SyncModelPermissionEntryWithStatus[];
}) => {
  return filter(
    permissions.map(
      permission =>
        permission.role_kind !== "REVOKED" &&
        permission.scope_kind === "COLLECTION_SCOPE" &&
        permission.collection_id
    )
  ) as string[];
};
